import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import asset from '../utils/assetUrl';

// Mismo orden en que aparecen las secciones en la pagina. Los que llevan `to`
// son paginas aparte, no secciones de la home.
const navLinks = [
  { label: 'Inicio', target: 'hero' },
  { label: 'La Conferencia', target: 'pilares' },
  { label: 'Fechas', target: 'locations' },
  { label: 'Cronograma', to: '/cronograma' },
  { label: 'Provincias', target: 'provincias' },
  { label: 'Testimonios', target: 'testimonios' },
  { label: 'Preguntas', target: 'faqs' }
];

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const scrollToTarget = useCallback((target) => {
    const el = document.getElementById(target);
    if (el) {
      const navOffset = 90; // adjust if nav height changes
      const elementY = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementY - navOffset,
        behavior: 'smooth'
      });
    }
  }, []);

  const handleNavClick = useCallback(
    (e, target) => {
      e.preventDefault();

      if (location.pathname !== '/') {
        navigate(`/#${target}`);
        setTimeout(() => scrollToTarget(target), 100);
      } else {
        scrollToTarget(target);
      }

      closeMenu();
    },
    [closeMenu, location.pathname, navigate, scrollToTarget]
  );

  useEffect(() => {
    // Close menu on route change and honor hash navigation.
    closeMenu();
    if (location.hash) {
      const target = location.hash.replace('#', '');
      setTimeout(() => scrollToTarget(target), 50);
    }
  }, [closeMenu, location.hash, scrollToTarget]);

  const handleLogoClick = useCallback(
    (e) => {
      e.preventDefault();
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => scrollToTarget('hero'), 100);
      } else {
        scrollToTarget('hero');
      }
      closeMenu();
    },
    [closeMenu, location.pathname, navigate, scrollToTarget]
  );

  const renderLinks = useMemo(
    () =>
      navLinks.map((link) => (
        <li key={link.target || link.to}>
          {link.to ? (
            // El router no vuelve arriba solo al cambiar de pagina.
            <Link to={link.to} onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>
              {link.label}
            </Link>
          ) : (
            <a href={`/#${link.target}`} onClick={(e) => handleNavClick(e, link.target)}>
              {link.label}
            </a>
          )}
        </li>
      )),
    [closeMenu, handleNavClick]
  );

  return (
    <nav className={`nav ${menuOpen ? 'nav--open' : ''}`}>
      <div className="nav__container container">
        <div className="logo">
          <a href="/#" onClick={handleLogoClick} aria-label="Conferencia para Canada">
            <img src={asset("/assets/images/Para_Canada_Conferencia_Logo_White.svg")} alt="Conferencia para Canada" />
          </a>
        </div>

        <div className={`nav__links ${menuOpen ? 'open' : ''}`}>
          <div className="nav__links-container">
            <ul>
              {renderLinks}
            </ul>
          </div>
        </div>

        <div className="nav__actions">
          <button
            type="button"
            className="button"
            onClick={(e) => handleNavClick(e, 'hero')}
          >
            Registrate
          </button>
          <button
            type="button"
            className="nav__toggle"
            aria-expanded={menuOpen}
            aria-label="Abrir menu de navegacion"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? 'Cerrar' : 'Menu'}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
